<template>
  <div class="my-3 py-2 container-fluid">
    <div class="row">
      <ul class="p-1 bg-transparent nav nav-pills nav-fill my-3" role="tablist">
        <li class="nav-item">
          <a
            class="px-0 py-1 mb-0 nav-link active"
            data-bs-toggle="tab"
            href="javascript:;"
            @click="showTeacherList"
            role="tab"
            aria-selected="true"
          >
            <span class="ms-1">{{ this.$t("teachers.teachers") }}</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="px-0 py-1 mb-0 nav-link"
            data-bs-toggle="tab"
            href="javascript:;"
            @click="showCourseList"
            role="tab"
            aria-selected="false"
          >
            <span class="ms-1">{{ this.$t("courses.courses") }}</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="px-0 py-1 mb-0 nav-link"
            data-bs-toggle="tab"
            href="javascript:;"
            @click="showSubcourseList"
            role="tab"
            aria-selected="false"
          >
            <span class="ms-1">{{ this.$t("subcourses.subcourses") }}</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="px-0 py-1 mb-0 nav-link"
            data-bs-toggle="tab"
            href="javascript:;"
            @click="showKidList"
            role="tab"
            aria-selected="false"
          >
            <span class="ms-1">{{ this.$t("kids.kids") }}</span>
          </a>
        </li>
        <li class="nav-item">
          <a
            class="px-0 py-1 mb-0 nav-link"
            data-bs-toggle="tab"
            href="javascript:;"
            @click="showParentList"
            role="tab"
            aria-selected="false"
          >
            <span class="ms-1">{{ this.$t("parents.parents") }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="col-12">
      <teacher-list
        v-if="areTeachersVisible"
        :teachers="teachers"
        :lastSeason="lastSeason"
        @get-teachers="fetchTeachers"
      />
    </div>
    <div class="col-12">
      <course-list
        v-if="areCoursesVisible"
        :courses="courses"
        :lastSeason="lastSeason"
        @get-courses="getCourses"
      />
    </div>
    <div class="col-12">
      <subcourse-list
        v-if="areSubcoursesVisible"
        :subcourses="subcourses"
        :lastSeason="lastSeason"
        @get-subcourses="fetchSubcourses"
      />
    </div>
    <div class="col-12">
      <kid-list
        v-if="areKidsVisible"
        :kids="kids"
        :lastSeason="lastSeason"
        @get-kids="fetchKids"
      />
    </div>
    <div class="col-12">
      <parent-list
        v-if="areParentsVisible"
        :parents="parents"
        :lastSeason="lastSeason"
        :closeEditForm="true"
        @fetch-parents="showParentList"
        @get-parents="fetchParents"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import setNavPills from "@/assets/js/nav-pills.js";
import TeacherList from "./components/TeacherList";
import CourseList from "./components/CourseList";
import SubcourseList from "./components/SubcourseList";
import KidList from "./components/KidList";
import ParentList from "./components/ParentList";

export default {
  name: "Deleted",
  components: {
    TeacherList,
    CourseList,
    SubcourseList,
    KidList,
    ParentList,
  },
  created() {
    this.fetchTeachers();
  },
  data() {
    return {
      areTeachersVisible: true,
      areCoursesVisible: false,
      areSubcoursesVisible: false,
      areKidsVisible: false,
      areParentsVisible: false,
      teachers: [],
      courses: [],
      subcourses: [],
      kids: [],
      parents: [],
      lastSeason: false,
    };
  },
  methods: {
    async fetchTeachers() {
      let response = await axios.get("/teacher/trashed");
      this.teachers = response.data.teachers;
      this.lastSeason = response.data.last_season;
    },
    async getCourses() {
      let response = await axios.get("/courses/trashed");
      this.courses = response.data.courses;
    },
    async fetchSubcourses() {
      const response = await axios.get("/subcourses/trashed");
      this.subcourses = response.data.subcourses;
    },
    async fetchKids() {
      const response = await axios.get("/kids/trashed");
      this.kids = response.data.kids;
    },
    async fetchParents() {
      let response = await axios.get("parents/trashed");
      this.parents = response.data.parents;
    },
    showTeacherList() {
      this.fetchTeachers();
      this.areTeachersVisible = true;
      this.hideCourseList();
      this.hideSubcourseList();
      this.hideKidList();
      this.hideParentList();
    },
    hideTeacherList() {
      this.areTeachersVisible = false;
    },
    showCourseList() {
      this.getCourses();
      this.areCoursesVisible = true;
      this.hideTeacherList();
      this.hideSubcourseList();
      this.hideKidList();
      this.hideParentList();
    },
    hideCourseList() {
      this.areCoursesVisible = false;
    },
    showSubcourseList() {
      this.fetchSubcourses();
      this.areSubcoursesVisible = true;
      this.hideTeacherList();
      this.hideCourseList();
      this.hideKidList();
      this.hideParentList();
    },
    hideSubcourseList() {
      this.areSubcoursesVisible = false;
    },
    showKidList() {
      this.fetchKids();
      this.areKidsVisible = true;
      this.hideTeacherList();
      this.hideCourseList();
      this.hideSubcourseList();
      this.hideParentList();
    },
    hideKidList() {
      this.areKidsVisible = false;
    },
    showParentList() {
      this.fetchParents();
      this.areParentsVisible = true;
      this.hideTeacherList();
      this.hideCourseList();
      this.hideSubcourseList();
      this.hideKidList();
    },
    hideParentList() {
      this.areParentsVisible = false;
    },
  },
  mounted() {
    this.$store.state.isAbsolute = true;
    setNavPills();
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
  },
};
</script>

<style>
.breadcrumb .text-white,
.text-white {
  color: #344767 !important;
}
</style>
